/**
 * Mail App Commands Export
 */

import { mailSearchMessagesCommand } from './mail_searchMessages';
import { mailReadMessageCommand } from './mail_readMessage';
import { mailWriteCommand } from './mail_write';
import { mailSendMessageCommand } from './mail_sendMessage';
import { mailCreateDraftCommand } from './mail_createDraft';
import { emailSendCommand } from './email_send';

export const mailAppCommands = [
  mailSearchMessagesCommand,
  mailReadMessageCommand,
  mailWriteCommand,
  mailSendMessageCommand,
  mailCreateDraftCommand,
  emailSendCommand,
];
